import BoardContentContext from '@/context/apps/board/BoardContentContext';
import { useContext } from 'react';

import { resolveNewsThumbnail, resolveNewsVideo } from '@/utils/newsThumbnail';

import BoardDetail from '@/components/apps/board/detail/BoardDetail';

import NewsThumbnail from './NewsThumbnail';

export default function NewsBoardDetail() {
  const { data } = useContext(BoardContentContext);
  const thumbnail = resolveNewsThumbnail(data);
  const videoSrc = resolveNewsVideo(data.file_info, data.bc.idx);

  return (
    <BoardDetail
      contentHeader={
        thumbnail || videoSrc ? (
          <NewsThumbnail
            thumbnail={thumbnail}
            videoSrc={videoSrc}
            title={data.bc.title}
          />
        ) : null
      }
    />
  );
}
